import {useContext} from "react";

import {KhanmigoSidebarContext, type KhanmigoSidebarState} from "./context.ts";

/**
 * Hook that provides the current state of the Khanmigo sidebar.
 */
export const useKhanmigoSidebarState = (): KhanmigoSidebarState =>
    useContext(KhanmigoSidebarContext);
